import React from 'react';

import { Tab } from '@ajaibid/components';

import { useGetOrderTypeOptions, useStockBuySellContext } from '../../hooks';
import { useEventTracker } from '../../../tracker';

const TabOrderType = () => {
  const { code, formState, formKey, formAction, dispatch } = useStockBuySellContext();
  const { orderTypeOptions } = useGetOrderTypeOptions();
  const { eventClickSwitchOrderType } = useEventTracker();

  const onChangeOrderType = (v) => {
    dispatch({ type: formAction.CHANGE_ORDER_TYPE, code, payload: v });
    eventClickSwitchOrderType({ type: v.key });
  };

  return (
    <Tab
      tabOptions={orderTypeOptions}
      activeTab={formState[formKey.TAB_ORDER_TYPE]}
      setActiveTab={onChangeOrderType}
      data-testid="tab-orderType"
    />
  );
};

export default TabOrderType;
